export const emailRegex = /^[\w\-.]+@(\w+\.)+\w+$/;

// txt.split(/(<\/?.>)/) //for links and bold